module.exports = __webpack_public_path__ + "img/wa.d539dc17.png";